export const locale = {
    lang: 'pl',
    data: {
        'New category': 'Nowa kategoria',
        'Edit category': 'Edycja kategorii',
        'Name': 'Nazwa',
        'Parent category': 'Nadrzędna kategoria',
        'ADD': 'Dodaj',
        'DELETE': 'Usuń',
        'SAVE': 'Zapisz',
    }
};
